/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import { Container, Toaster } from "@coreai/component-library";
import { Link } from "react-router-dom";
import "./NavigationBar.css";
import { useNavBarLabelsService } from "../../../services/useNavBarLabelsService";
import { css } from "@emotion/react"

const CommonNavigationBar: React.FC = () => {
  const { navbarLabels } = useNavBarLabelsService();


  useEffect(() => {
    // Find the first <svg> inside the ButtonIcon component    
    const icons = document.querySelectorAll("svg");
    icons.forEach((icon) => {
      // Get the "name" attribute from the <svg>
      const iconName = icon.getAttribute("name");
      if (iconName) {
        icon.setAttribute("role", "img");
        icon.setAttribute("aria-label", iconName.replace("-", " ")); // Convert "edit-01" → "edit 01"
      } else {
        icon.setAttribute("aria-hidden", "true"); // Hide if no name is available
      }
    });     
  }, []);

  const navigationBar = css`
    justify-content: center;
    .language-selector {
      button {
        padding: 5px;
        overflow: hidden;
      }
    }
  `;

    const toasterWraper = css`
      position: absolute;
      top: 0px;
      right: 0px;
      @media (max-width: 640px) {
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      z-index: 1000;
      width: 90%;
    }
    `;

  return (
    <Container variant="row" className="navigation-bar" css={[navigationBar]} >
      <div className="logo-container">
        <Link to="/signin" className="logo-link">
          {
            (navbarLabels?.logo) && (
              <img src={navbarLabels?.logo} alt="Logo" className="agw-logo" />
            )
          }
          <h1 className="app-title">{navbarLabels?.title || ""}</h1>
        </Link>
      </div>
      <div css={toasterWraper}>
        <Toaster />
      </div>
    </Container>
  );
};

export default CommonNavigationBar;
